import { Box, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import { AddCircleIcon } from "../icons/AddCircleIcon";
import { AddedBubbleIcon } from "../icons/AddedBubbleIcon";

export interface SelectableCardProps {
  image: string;
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
}

export function SelectableCard({
  image,
  title,
  description,
  isSelected,
  onClick,
}: SelectableCardProps) {
  const cardWidth = useBreakpointValue({
    base: "100%",
    lg: "313px",
  });

  const titleFontSize = useBreakpointValue({
    base: "18px",
    lg: "22px",
  });

  return (
    <Flex
      width={cardWidth}
      height="100%"
      cursor="pointer"
      onClick={onClick}
      position="relative"
      borderRadius="24px"
      transition="transform 0.2s ease-in-out"
      direction="column"
      _hover={{
        transform: "scale(1.02)",
      }}
    >
      {/* Gradient border wrapper */}
      <Flex
        position="relative"
        borderRadius="24px"
        padding={isSelected ? "2px" : "1px"}
        direction="column"
        flex="1"
        transition="padding 0.2s ease-in-out, background 0.2s ease-in-out"
        background={
          isSelected
            ? "linear-gradient(45deg, #FF5A2C 0%, #FF5A2C66 50%, #FF5A2C 100%)"
            : "linear-gradient(45deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.3) 100%)"
        }
      >
        {/* Inner card content */}
        <Flex
          bg="transparent.black.80"
          borderRadius="23px"
          overflow="hidden"
          direction="column"
          flex="1"
        >
          {/* Image with padding */}
          <Box padding="24px 24px 0 24px">
            <Box
              width="100%"
              aspectRatio={265 / 123}
              overflow="hidden"
              borderRadius="8px"
            >
              <Box
                as="img"
                src={image}
                alt={title}
                aspectRatio={265 / 123}
                width="100%"
                height="100%"
                objectFit="cover"
              />
            </Box>
          </Box>

          {/* Content */}
          <Flex direction="row" padding="24px" alignItems="stretch" flex="1">
            {/* Text content */}
            <Flex direction="column" flex="1">
              {/* Title */}
              <Text
                fontSize={titleFontSize}
                fontWeight="600"
                color="neutral.white"
                lineHeight="100%"
                letterSpacing="-0.5px"
                fontFamily="Roboto"
              >
                {title}
              </Text>

              {/* Description */}
              <Text
                fontSize="16px"
                fontWeight="400"
                color="neutral.400"
                lineHeight="130%"
                marginTop="8px"
                fontFamily="Roboto"
              >
                {description}
              </Text>
            </Flex>

            {/* Icon column */}
            <Flex direction="column" justifyContent="flex-end">
              <Box
                color={isSelected ? "blaze.blaze" : "transparent.white.30"}
                transition="color 0.2s ease-in-out"
              >
                {isSelected ? (
                  <AddedBubbleIcon boxSize="32px" color="blaze.blaze" />
                ) : (
                  <AddCircleIcon boxSize="32px" />
                )}
              </Box>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
